import React, { useState } from 'react';

import ResultsPerPage from '@Containers/ResultsPagination/ResultsPerPage/ResultsPerPage';
import Pagination from '@Containers/ResultsPagination/Pagination/Pagination';
import PropTypes from 'prop-types';
import './RsPaging.custom.scss';

function RsPaging({ pageSize, currentPage, totalPages, totalItems, pageSizeValues, onChange, renderPageSize }) {
  const [isOpen, setOpen] = useState(false);
  const isGotToPageVisible = totalPages > 5;
  const isPageSizeVisible = renderPageSize && totalItems >= Math.min(...pageSizeValues);
  const pageSizeValuesAdopted = pageSizeValues.map((value) => ({ value, label: value }));
  return (
    <nav className="retro-synthesis-pagination rx-list els-pagination-wrapper">
      {isPageSizeVisible && (
        <ResultsPerPage
          resultsPerPage={pageSize}
          setResultsPerPage={(newPageSize) => onChange({ size: newPageSize, currentPage })}
          dropdownOpen={isOpen}
          setDropdownOpen={setOpen}
          dropdownValues={pageSizeValuesAdopted}
        />
      )}
      {currentPage && totalItems && (
        <Pagination
          currentPage={currentPage}
          resultsPerPage={pageSize}
          totalPages={totalPages}
          totalItems={totalItems}
          shouldDisplayGoToPage={isGotToPageVisible}
          onSelect={(number) => onChange({ size: pageSize, page: number - 1 })}
        />
      )}
    </nav>
  );
}

export default RsPaging;

RsPaging.propTypes = {
  pageSize: PropTypes.number,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
  pageSizeValues: PropTypes.array,
  onChange: PropTypes.func,
  renderPageSize: PropTypes.bool,
};

RsPaging.defaultProps = {
  pageSize: 30,
  currentPage: 0,
  totalPages: 0,
  pageSizeValues: [15, 30, 45, 60, 75, 90, 100],
  onChange: () => null,
  renderPageSize: true,
};
